import { Field, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'

@InputType()
export class FinalizeOrderServiceArgs extends ActionArgs {
  @Field(() => String)
  orderId: string
}
